module.exports = __webpack_public_path__ + "img/yml_gallery13.5b0d618e.jpg";